// Globals
import { useTranslation } from 'react-i18next';

// Components
import {
  StyledTitleModal,
  StyledButton,
  StyledForm,
  StyledFormItem,
  StyledInput,
  StyledTextArea,
} from './UpdateOrderClientModalStyles';
import { IFormInstance, Modal, ModalSize, PhoneInput } from '@/components';

// Helpers
import {
  TUpdateOrderClientFormValues,
  UpdateOrderClientFormFieldsNames,
  useUpdateOrderClientFormRules,
} from '../../helpers';
interface UpdateOrderClientModalProps {
  isLoading: boolean;
  formInstance: IFormInstance;
  initialValues?: TUpdateOrderClientFormValues;
  isOpenUpdateOrderClientModal: boolean;
  closeUpdateOrderClientModal: () => void;
  handleUpdateOrderClient: () => void;
}

const UpdateOrderClientModal = ({
  isLoading,
  formInstance,
  initialValues,
  isOpenUpdateOrderClientModal,
  closeUpdateOrderClientModal,
  handleUpdateOrderClient,
}: UpdateOrderClientModalProps) => {
  const { t } = useTranslation(['orders']);
  const validationRules = useUpdateOrderClientFormRules(t);

  return (
    <Modal visible={isOpenUpdateOrderClientModal} onCancel={closeUpdateOrderClientModal} size={ModalSize.LARGE}>
      <StyledForm form={formInstance} onFinish={handleUpdateOrderClient} initialValues={initialValues}>
        <StyledTitleModal>{t('orders_update_client_modal_title')}</StyledTitleModal>
        <StyledFormItem
          label={t('orders_update_client_name_label')}
          name={UpdateOrderClientFormFieldsNames.NAME}
          rules={validationRules[UpdateOrderClientFormFieldsNames.NAME]}
        >
          <StyledInput />
        </StyledFormItem>
        <StyledFormItem
          label={t('orders_update_client_phone_label')}
          name={UpdateOrderClientFormFieldsNames.PHONE}
          rules={validationRules[UpdateOrderClientFormFieldsNames.PHONE]}
        >
          <PhoneInput />
        </StyledFormItem>
        <StyledFormItem
          label={t('orders_update_client_email_label')}
          name={UpdateOrderClientFormFieldsNames.EMAIL}
          rules={validationRules[UpdateOrderClientFormFieldsNames.EMAIL]}
        >
          <StyledInput />
        </StyledFormItem>
        <StyledFormItem
          label={t('orders_update_client_description_label')}
          name={UpdateOrderClientFormFieldsNames.DESCRIPTION}
          rules={validationRules[UpdateOrderClientFormFieldsNames.DESCRIPTION]}
        >
          <StyledTextArea />
        </StyledFormItem>
        <StyledButton onClick={handleUpdateOrderClient} disabled={isLoading} type="primary">
          {t('orders_update_client_modal_button')}
        </StyledButton>
      </StyledForm>
    </Modal>
  );
};

export default UpdateOrderClientModal;
